'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import Text from '@/app/cc/_component/ui/common/Text/Text';
import styles from '@/app/cc/_component/ui/section/AnsimUsage/AnsimUsage.module.scss';
import useOpenAppInstall from '@/app/cc/_hooks/useOpenAppInstall';
import { useOpenModal } from '@/app/cc/_hooks/useOpenModal';
import { sendGA } from '@/app/cc/_util/sendGA';
import { useDeviceInfo } from '@/app/cc/DeviceContext';
import { useKind } from '@/app/cc/KindContext';
export function FirstUsageStepContent(t0) {
  const $ = _c(8);
  const {
    isBeforeContract
  } = t0;
  const kind = useKind();
  const {
    deviceType,
    clientInfo
  } = useDeviceInfo();
  let t1;
  if ($[0] !== clientInfo || $[1] !== deviceType) {
    t1 = {
      type: "town",
      deviceType,
      clientInfo
    };
    $[0] = clientInfo;
    $[1] = deviceType;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const openAppInstall = useOpenAppInstall(t1);
  const openModal = useOpenModal();
  let t2;
  if ($[3] !== isBeforeContract || $[4] !== kind || $[5] !== openAppInstall || $[6] !== openModal) {
    t2 = <>{isBeforeContract ? <><div><Text as="p" category="body" variant="r1" color="var(--color-gray-900)">다양한 부동산 매물을 많이 보유하고 있는 이실장에서 마음에 드는 매물과 안심케어 중개사 탐색 단계부터 함께해 보세요.</Text><div className={styles.consultationButtonWrapper}>{kind !== "LEE_APP" && <button type="button" className={styles.consultationButton} onClick={() => {
              sendGA("beforeUsageAppdown");
              openAppInstall();
            }}><span>이실장 App 다운로드</span><Image src="/cc/image/icon_right_arrow_orange.svg" alt={"\uC774\uC2E4\uC7A5 App \uB2E4\uC6B4\uB85C\uB4DC"} width={8} height={16} /></button>}<button className={styles.consultationButton} type="button" onClick={_temp}><span>안심 동참 중개사 찾기 링크</span><Image src="/cc/image/icon_right_arrow_orange.svg" alt={"\uC548\uC2EC \uB3D9\uCC38 \uC911\uAC1C\uC0AC \uCC3E\uAE30"} width={8} height={16} /></button></div></div><Text as="p" category="body" variant="r1" color="var(--color-gray-900)">※ 매물 상태 및 계약 당사자 등에 따라 가입이 제한될 수 있습니다.</Text></> : <><div><Text as="p" category="body" variant="r1" color="var(--color-gray-900)">가입 가능 여부 확인을 도와드릴게요</Text><button className={styles.consultationButton} type="button" onClick={() => {
            sendGA("afterUsageReserveClick");
            openModal("consultation");
          }}><span>상담 신청하기</span><Image src="/cc/image/icon_right_arrow_orange.svg" alt={"\uC0C1\uB2F4 \uC2E0\uCCAD\uD558\uAE30"} width={8} height={16} /></button></div><Text as="p" category="body" variant="r1" color="var(--color-gray-900)">※ 매물 상태 및 계약 당사자 등에 따라 가입이 제한될 수 있습니다.</Text></>}</>;
    $[3] = isBeforeContract;
    $[4] = kind;
    $[5] = openAppInstall;
    $[6] = openModal;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function _temp() {
  sendGA("beforeUsageRealtor");
  document.getElementById("ansim_partner")?.scrollIntoView({
    behavior: "smooth",
    block: "start"
  });
}